import i18n from 'i18next'

export const getMappedErrors = errorMessage => {
  const t = i18n.getFixedT(null, 'common')

  if (errorMessage.includes('ON CONFLICT DO UPDATE')) {
    return t('errors.duplicateRecord')
  }
  if (errorMessage.includes('user_has_available_amount')) {
    return t('errors.cannotRemoveHasUsers')
  }

  return errorMessage
}
